/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Published_AtInputs */

const fr_changelog_published_at = /** @type {(inputs: Changelog_Published_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publié le`)
};

/**

* @param {Changelog_Published_AtInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_published_at = /** @type {((inputs?: Changelog_Published_AtInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Published_AtInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_published_at(inputs)
});